export default {
  search: (queryObject) => `profile/search?${prepareQuery(queryObject)}`,
  show: (profileID) => `/profile/search/show/${profileID}`,
  stats: `/profile/search/stats`,
};

function prepareQuery(queryObject) {
  let query = null;
  for (const [key, value] of Object.entries(queryObject)) {
    if (query) {
      query = `${query}&${key}=${value}`;
    } else {
      query = `${key}=${value}`;
    }
  }
  return query;
}
